// react
import React from 'react';

// components
import DoctorsList from './DoctorsList';
import Skeletonize from '../../Skeletons/Skeletonize';

// types
import { DoctorAvailabilityData } from 'data-types';

// utils
import { translate } from '../../utils/translator'

type Props = {
	language: string;
	handleSelectDoctor: (doctorAvailabilityData: DoctorAvailabilityData) => void;
	doctorsAvailabilityData: DoctorAvailabilityData[];
	isLoading: boolean;
	layoutWithDoctors: boolean;
}

const ChooseDoctorView: React.FC<Props> = ({ language, handleSelectDoctor, doctorsAvailabilityData, isLoading, layoutWithDoctors }) => {

	return (
		<section
			className={`
				grid
				grid-rows-[auto_1fr]
				no-scrollbar
				min-h-0
				overflow-y-auto
			`}
		>
			<div
				id="choose-doctor-headers-container"
				className="py-4"
			>
				<Skeletonize
					isLoading={isLoading}
					className='w-2/3 h-[32px] mt-4'
					animation='syncWave pulse'
				>
					<h1
						id="choose-doctor-header-main-title"
						className="
							text-[32px]
							font-medium
							animate-fade-in-up-10
						"
					>
						{translate(language, 'choose_doctor', 'choose_doctor_page/main_title/choose_your')} <span className="text-[#1C9875]">{translate(language, 'choose_doctor', 'choose_doctor_page/main_title/doctor')}</span>
					</h1>
				</Skeletonize>


				<Skeletonize
					isLoading={isLoading}
					className='w-1/2 h-[16px] md:h-[20px] mt-3 mb-4'
					animation='syncWave pulse'
				>
					<h2
						id="choose-doctor-header-sub-title"
						className="
							text-[16px] md:text-[20px]
							font-medium
							py-3
							animate-fade-in-up-10
						"
					>
						{translate(language, 'choose_doctor', 'choose_doctor_page/sub_title' )}
					</h2>
				</Skeletonize>
			</div>

			<DoctorsList 
				language={language}
				doctorsAvailabilityData={doctorsAvailabilityData}
				selectDoctorHandler={handleSelectDoctor}
				isLoading={isLoading}
				layoutWithDoctors={layoutWithDoctors}
			/>
		</section>
	);
}

export default ChooseDoctorView;
